var map = {
	"./Bolt Food.png": "19d8",
	"./Deliveroo.png": "3d4b",
	"./Glovo.png": "fb3b",
	"./Just Eat.png": "d5bd",
	"./Marca.png": "586d",
	"./Takeaway.com.png": "26b6",
	"./Uber Eats.png": "d420"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a49a";